/// <amd-module name="Test/TestPlansHubRefresh/TestCasesImportModule/Redux/TestCasesImportPanelModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { TestCasesImportPanelReducer } from "./TestCasesImportPanelReducer";
import { ITestCasesImportPanelAwareState } from "./TestCasesImportPanelContracts";

export const TestCasesImportPanelModule: ISagaModule<ITestCasesImportPanelAwareState> = {
    id: "testcases-import-panel",
    reducerMap: {
        testCasesImportPanelState: TestCasesImportPanelReducer,
    },
    sagas: []
};
